import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { taxInvoiceAction } from './tax-invoice.actions';
import { TaxInvoiceService } from '../service/tax-invoice.service';

@Injectable()
export class TaxInvoiceEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private taxInvoiceService: TaxInvoiceService
  ) {}

  taxInvoiceListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(taxInvoiceAction.taxInvoiceListRequest),
      tap((_) => this.logger.debug('@Effect [Tax Invoice] tax invoice list request ')),
      switchMap(({ payload }) => {
        return this.taxInvoiceService.list({ ...payload }).pipe(
          map((response) => {
            return taxInvoiceAction.taxInvoiceListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  taxInvoiceDetailRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(taxInvoiceAction.viewTaxInvoiceRequest),
      tap((_) => this.logger.debug('@Effect [Tax Invoice] tax invoice detail request ')),
      switchMap(({ receiptNo }) => {
        return this.taxInvoiceService.detail(receiptNo).pipe(
          map((response) => taxInvoiceAction.viewTaxInvoiceResponse({ response })),
          catchError((err) => of(err))
        );
      })
    );
  });

  agentTransactionDetailRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(taxInvoiceAction.viewAgentTransactionRequest),
      tap((_) => this.logger.debug('@Effect [Tax Invoice] agent transaction detail request ')),
      switchMap(({ receiptNo }) => {
        return this.taxInvoiceService.agentTransactionDetail(receiptNo).pipe(
          map((response) => taxInvoiceAction.viewAgentTransactionResponse({ response })),
          catchError((err) => of(err))
        );
      })
    );
  });
}
